// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73f0eb4d","229":"4ebafd05","239":"b36ccc04","453":"eddef56c","455":"3d8f53c9"}[chunkId] + ".chunk.js";
};